import React from "react";
import Hint from "../../utils/Hint/Hint";

// Import subsections
import ActiveOrders from "./ActiveOrders/ActiveOrders";

const OrdersSection = ({
  activeOrders,
  setActiveOrders,
  isActiveOrdersLoading,
  handleRefreshOrder,
  handleUpdateOrderAdmin,
  handleUpdateOrderChef,
  handleConfirmOrder,
  handleInactivateOrder,
  fetchActiveOrders
}) => {
  return (
    <section className="section ordersSection">
      <Hint
        hintHeading="Current orders"
        hintText={`
        <div>
        <div>
          The interface responsible for handling current orders.
          </div>
          <div>
          Each order card contains information about the order (order number, type, fulfillment and payment status, order contents, etc.) and a set of control buttons.
          </div>
          <div style="margin-top: .3em;">
          The system supports online payment and automated database updates on customer-dependent events.
          </div>
          <div>
          In full version of the application, admin and employee users get notified about new orders and changes of an order's status (order was paid, order was cancelled by the customer) with a real-time notifications system.
          </div>
          <div>
          A fulfilled or cancelled order can be moved to history and made available at the <a href="/orders_stats">orders statistics page</a>.
          </div>
          <div style="margin-top: .3em;">
          This order-handling e-commerce system can be implemented seamlessly in any small or medium-size catering business workflow. The interface is aimed to be intuitive and requiring no special technical skills or advanced training.
          </div>
          <div>
          The actual implementation can be adjusted to the company's requirements and business processes.
          </div>
          </div>
        `}
        openOnMount={false}
        top="5em"
        right="3em"
      />
      <h2 className="sectionHeading">Active Orders</h2>
      <ActiveOrders
        activeOrders={activeOrders}
        setActiveOrders={setActiveOrders}
        isActiveOrdersLoading={isActiveOrdersLoading}
        handleUpdateOrderAdmin={handleUpdateOrderAdmin}
        handleUpdateOrderChef={handleUpdateOrderChef}
        handleConfirmOrder={handleConfirmOrder}
        handleInactivateOrder={handleInactivateOrder}
      />
    </section>
  );
};

export default OrdersSection;
